import React, { useState, useEffect } from "react";
import "./Dashboard.css"; // See CSS below
import logoImage from "../../assets/images/AstrocureLogo.svg";
import DownArrow from "../../assets/images/DownArrow.svg";
import UpArrow from "../../assets/images/UpArrow.svg";
import ProfileImage from "../../assets/images/ProfileImage.svg";
import Youtube from "../../assets/images/youtube.svg";
import BiCam from "../../assets/images/bi_camera-reels.svg";
import Cnt1 from "../../assets/images/cnt1.svg";
import Ellipse from "../../assets/images/Ellipse.svg";
import ChevronRight from "../../assets/images/chevron-right.svg";
import LikeIconColored from "../../assets/images/LikeIconColored.svg";
import LikeIconUnColored from "../../assets/images/LikeIconUnColored.svg";
import Eye_filled from "../../assets/images/carbon_view-filled.svg";
import Eye_Un_filled from "../../assets/images/carbon_view-un-filled.svg";
import ShareIcon from "../../assets/images/forword.svg";
import Border from "../../assets/images/border.svg";
import PlusIcon from "../../assets/images/plus-icon.svg";
import Share_disabled from "../../assets/images/share_disabled.svg";
import { useNavigate } from "react-router-dom";
import Header from "./../../Components/Header/Header";
import { useUser } from "../../Context/UserContext";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const formatPublishedAt = (dateString) => {
  const date = dayjs(dateString);
  if (!date.isValid()) return "";
  return `${date.format("h:mma").toLowerCase()} · ${date.fromNow()}`;
};

const Dashboard = () => {
  const [profileOpen, setProfileOpen] = useState(false);
  const navigate = useNavigate();
  const { user, dashboardData } = useUser();


  const stats = [
    {
      label: "Total View",
      value: dashboardData?.stats?.totalViews || "0",
      caption: "This month",
      trend: "down",
      belowCaption: "View",
    },
    {
      label: "Total Earnings",
      value: dashboardData?.stats?.totalEarnings || "0",
      caption: "This month",
      trend: "down",
    },
    {
      label: "Today’s Earnings",
      value: dashboardData?.stats?.todaysEarnings || "0",
      caption: "",
      trend: "up",
    },
    {
      label: "Content Awaiting Approval",
      value: dashboardData?.stats?.contentAwaitingApproval || "0",
      caption: "",
      trend: null,
      navigate: "/view-awaiting-list",
    },
  ];

  const contentLibrary = [
    { title: "Total Videos", count: `${dashboardData?.contentSummary?.totalVideos || "0"} Videos Uploaded`, color: "purple" },
    { title: "Total Reels", count: `${dashboardData?.contentSummary?.totalReels || "0"} Reels Uploaded`, color: "orange" },
    { title: "Total Story", count: `${dashboardData?.contentSummary?.totalStories || "0"} Story Uploaded`, color: "green" },
  ];

  const displayedScheduledContent =
    dashboardData?.scheduledContent?.slice(0, 3) || [];
  const displayedRecentPublishedContent =
    dashboardData?.recentPublishedContent?.slice(0, 4) || [];
  const displayedSubscribers = dashboardData?.subscribers?.slice(0, 3) || [];
  const subscriberCount =
    dashboardData?.profile?.subscribersCount ??
    dashboardData?.subscribers?.length ??
    0;

  const toggleProfile = () => setProfileOpen(!profileOpen);

  const Avatar = () => {
    if (user?.profileUrl) {
      return (
        <img
          src={user?.profileUrl}
          alt={user?.fullName || user?.userName || "Profile"}
          className="profile-avatar"
        />
      );
    }

    const initials = (user?.fullName || user?.userName || "")
      .split(" ")
      .filter(Boolean)
      .map((n) => n[0])
      .slice(0, 1)
      .join("") || "?";

    return <div className="dash-profile-initials">{initials}</div>;
  };

  const handleSubscribers = () => {
    navigate("/subscribers");
  };

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await window.fetch(
          "https://s3.ap-south-1.amazonaws.com/dev-assets.astrocure.co.in/signs_vs_planets_vs_houses_astrology_explained_vedic_astrology_thumbnail-1785493989175-xeogdettbjngptej2y19f.jpg",
          {
            method: "PUT",
          }
        );
        const data = await response.json();
        console.log("Dashboard Data:", data);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchDashboardData();
  }, []);
  return (
    <div className="dashboard">
      <div className="dashboard-bg-stripe"></div>
      <Header />
      <main className="dashboard-main">
        <div className="dashboard-top">
          <div>
            <h1 className="dashboard-title">Dashboard</h1>
            <div className="dashboard-user-row">
              <Avatar />
              <div>
                <div className="user-name">{user?.fullName}</div>
                <div className="user-handle">{user?.userName}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="stats-grid">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="stat-card stat-soft"
              onClick={() => navigate(stat?.navigate)}
            >
              <div className="stat-label">{stat.label}</div>

              {/* "This month" text in green */}
              <div className="stat-sub">{stat.caption || ""}</div>

              <div className="stat-value-row">
                <img src={Border} className="stat-img" />
                <span className="stat-value">{stat.value}</span>

                {/* Black Square Arrow Icon */}
                {stat.trend && (
                  <div className="stat-trend-box">
                    {stat.trend === "down" ? (
                      <img src={DownArrow} alt="Down Arrow" />
                    ) : (
                      <img src={UpArrow} alt="Down Arrow" />
                    )}
                  </div>
                )}
              </div>
              {stat.belowCaption && (
                <div className="stat-below-caption">{stat.belowCaption}</div>
              )}
            </div>
          ))}
        </div>

        <div className="library-section">
          <h3 className="content-lib">My Content Library</h3>
          <div className="library-grid">
            {contentLibrary.map((item, i) => (
              <div key={i} className={`library-card ${item.color}`}>
                <div className="lib-title">{item.title}</div>
                <div className="content-align">
                  {/* <div className="circle">{item.title[0]}</div> */}
                  <div className="circle">
                    {`${item.count.split(" ")[0]} ${item.count.split(" ")[1][0]}`}
                  </div>
                  <div className="lib-count">{item.count}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="content-section">
          <div className="left-panel">
            <div className="upload-section">
              <h3 className="upload-heading">Upload Content</h3>

              {/* Story Upload */}
              <div
                className="upload-story-card"
                onClick={() => (window.location.href = "/upload-story")}
              >
                <div className="story-avatar-wrapper">
                  <div className="story-avatar">
                    <img src={ProfileImage} alt="Story" />
                  </div>
                  {/* <div className="story-plus">+</div> */}
                  <img src={PlusIcon} className="story-plus" />
                </div>
                <div className="story-text">Add Story</div>
              </div>

              {/* Video & Reel */}
              <div className="upload-grid">
                <div
                  className="upload-card"
                  onClick={() => {
                    sessionStorage.removeItem("uploadVideoDraft");
                    sessionStorage.removeItem("previousVideos");
                    window.location.href = "/upload-video";
                  }}
                >
                  <div className="upload-icon-box">
                    {" "}
                    <img src={Youtube} alt="Story" />
                  </div>

                  <span>Upload Videos</span>
                </div>

                <div
                  className="upload-card"
                  onClick={() => (window.location.href = "/upload-reel")}
                >
                  <div className="upload-icon-box">
                    {" "}
                    <img src={BiCam} alt="Story" />
                  </div>
                  <span>Upload Reel</span>
                </div>
              </div>
            </div>

            <div className="post-section">
              <div className="recent-header-row">Recent Published Content</div>

              <div className="recent-grid">
                {displayedRecentPublishedContent.map((content, index) => (
                  <div
                    key={content.id || index}
                    className="recent-card"
                  >
                    <div className="recent-thumb">
                      <img
                        className="recent-thumb-image"
                        src={
                          content?.contentType === "Video"
                            ? content.thumbnailImage
                            : content?.contentType === "Story"
                              ? content?.thumbnailImage === ""
                                ? content?.storyUrl
                                : content?.thumbnailImage
                              : content?.generatedThumbnail
                        }
                        alt={content.title || content.caption || "Published content"}
                      />
                      <div className="recent-overlay" />
                    </div>
                    <div className="recent-content">
                      <div className="recent-title">{content.title ?? content.caption}</div>
                      <div className="recent-time-meta">
                        {formatPublishedAt(content.publishedAt)}
                      </div>
                      <div className="recent-stats">
                        <div className="recent-stat-item">
                          <span className="recent-like-badge">
                            <img src={LikeIconColored} alt="Like" />
                            {content.likesCount}
                          </span>
                        </div>
                        <div className="recent-stat-item">
                          <img src={Eye_filled} alt="view" />
                          <span className="recent-views-count">
                            {content.viewsCount} views
                          </span>
                        </div>
                        <div className="recent-stat-item">
                          <img src={ShareIcon} alt="share" />
                          <span className="recent-share-count">
                            {content.shareCount}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="recent-footer">
                <div
                  className="view-all-videos"
                  onClick={() => navigate("/content")}
                >
                  View all Videos <img src={ChevronRight} alt="Chevron Right" />
                </div>
              </div>
            </div>
          </div>
          <div className="right-panel">
            <div className="scheduled-section">
              <h3 className="scheduled-heading">Scheduled Content</h3>

              {displayedScheduledContent.length > 0 ? (
                displayedScheduledContent.map((item, i) => (
                  <div key={item.id || i} className="scheduled-item">
                    <div className="scheduled-left">
                      <div className="date-badge">
                        <div className="date-number">{dayjs(item.scheduledAt).format("DD")}</div>
                        <div
                          className={`date-month ${item.contentType === "Video"
                              ? "badge-peach"
                              : item.contentType === "Reel"
                                ? "badge-yellow"
                                : "badge-purple"
                            } `}
                        >
                          {dayjs(item.scheduledAt).format("MMMM")}
                        </div>
                      </div>

                      <div className="scheduled-info">
                        <div className="scheduled-title">{item.title || item?.caption}</div>
                        <div className="scheduled-meta">@{item.contentType}</div>
                        <div className="scheduled-time">{dayjs(item.scheduledAt).format("hh:mm A")}</div>
                      </div>
                    </div>

                    <div className="scheduled-thumb">
                      <img
                        className={`${item?.contentType === "Video" ? "scheduled-thumb-video" : "scheduled-thumb-reel"}`}
                        src={
                          item?.contentType === "Video"
                            ? item.generatedThumbnail
                            : item?.contentType === "Story"
                              ? item?.thumbnailImage === ""
                                ? item?.storyUrl
                                : item?.thumbnailImage
                              : item?.reelUrl
                        }
                        alt="Scheduled content thumbnail"
                      />
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-scheduled-content">
                  No scheduled content available.
                </div>
              )}
              {displayedScheduledContent.length > 0 && (
                <div className="followers-footer">
                  <div
                    className="view-more"
                    onClick={() => navigate("/scheduled-content")}
                  >
                    View More <img src={ChevronRight} alt="Chevron Right" />
                  </div>
                </div>
              )}
            </div>

            <div className="followers-section">
              <div className="followers-header">
                Your Subscribers : <span>{subscriberCount}</span> Subscribers
              </div>

              {displayedSubscribers.map((item, i) => {
                const subscriber = item?.subscriber || {};
                const avatarSrc = subscriber.profileUrl || Ellipse;
                const name = subscriber.userName;
                const handle = subscriber.userName && subscriber.userName !== subscriber.fullName ? subscriber.userName : null;
                const initials = (subscriber.userName || "")
                  .split(" ")
                  .filter(Boolean)
                  .map((n) => n[0])
                  .slice(0, 1)
                  .join("") || "?";
                return (
                  <div key={item.id || i} className="follower-item">
                    {subscriber.profileUrl ? (
                      <img src={avatarSrc} alt={name} className="profile-avatar" />
                    ) : (
                      <div className="dash-profile-initials">{initials}</div>
                    )}

                    <div className="follower-details">
                      <div className="follower-name">{name}</div>
                      <div className="follower-count">{name}</div>
                      <div className="follower-time">

                        {dayjs(item.createdAt).format("D MMM [at] h:mm A")}

                      </div>
                    </div>
                  </div>
                );
              })}

              <div className="followers-footer">
                <div className="view-followers" onClick={handleSubscribers}>
                  View all Subscribers{" "}
                  <img src={ChevronRight} alt="Chevron Right" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
